import { Currency } from 'app/components/FormFields/Currency';
import { PersonalLoanConfirmation } from 'app/components/PersonalLoan/PersonalLoanConfirmation';
import { FieldNames } from 'app/models/fields/names';
import { SHARED } from 'app/models/questions/shared';
import {
  PERSONAL_LOAN_INQUIRY_FINAL_QUESTION,
  PERSONAL_LOAN_INQUIRY_LOAN_AMOUNT_QUESTION,
} from 'app/models/sections/constants';
import { Question } from 'app/models/types';

/**
 * Takes in a field name and returns the corresponding personal loan
 * question
 *
 * @param {string} name Field name
 * @returns Question with matching field name
 */
export const personalLoanInquiryQuestionByName = (name: string): Question => {
  return PERSONAL_LOAN_INQUIRY_QUESTIONS.find((question) => question.name === name) as Question;
};

/**
 * Takes in a question id and returns the corresponding personal loan
 * question
 *
 * @param {number} id Question id
 * @returns Question with matching id
 */
export const personalLoanInquiryQuestionById = (id: number): Question => {
  return PERSONAL_LOAN_INQUIRY_QUESTIONS.find((question) => question.id === id) as Question;
};

/**
 * Takes in an array of field names and returns an array of questions
 *
 * @param {string[]} [names=[]] Field names
 * @returns Questions matching field names
 */
export const personalLoanInquiryQuestionsByName = (names: string[] = []): Question[] => {
  const questions: Question[] = [];
  for (const name of names) {
    questions.push(personalLoanInquiryQuestionByName(name));
  }
  return questions;
};

const PERSONAL_LOAN_INQUIRY_QUESTIONS: Question[] = [
  {
    id        : PERSONAL_LOAN_INQUIRY_LOAN_AMOUNT_QUESTION,
    component : Currency,
    name      : FieldNames.loanAmount,
    label     : 'Loan Amount',
    hideTitle : true,
    validator : {
      type: 'isBetween',
      param: [FieldNames.minLoanAmount, FieldNames.maxLoanAmount],
    },
  },
  {
    id: 1002,
    ...SHARED[FieldNames.firstName],
  },
  {
    id: 1003,
    ...SHARED[FieldNames.middleName],
  },
  {
    id: 1004,
    ...SHARED[FieldNames.lastName],
  },
  {
    id: 1005,
    ...SHARED[FieldNames.phone],
  },
  {
    id: 1006,
    ...SHARED[FieldNames.email],
  },
  {
    id: 1007,
    ...SHARED[FieldNames.dateOfBirth],
  },
  {
    id: 1008,
    ...SHARED[FieldNames.suffixName],
  },
  {
    id          : PERSONAL_LOAN_INQUIRY_FINAL_QUESTION,
    component   : PersonalLoanConfirmation,
    name        : 'FinalPage',
  },
];
